<template>
  <div>
    <modal-cadastro-questao ref="modalCadastroQuestao"
                            :professores="professores"
                            :modalidades="modalidades"
                            :fontes="fontes"
                            :publicoAlvo="publicoAlvo"
                            :cursos="cursos"
                            :modulos="modulos"
                            :licoes="licoes"
                            :questao-edicao="questaoEdicao"
                            @questaoSalva="buscarQuestoes" />

    <h3 class="mt-4 mb-3">Insira as informações gerais <a tabindex="0" role="button" title="" class="bs-popover" id="link-button"><i class="fas fa-info-circle"></i></a></h3>
    <b-popover target="link-button" triggers="focus">
      Ao preencher essas informações, a lista de questões disponíveis irá se adaptar ao conteúdo que precisa.
    </b-popover>
    <div class="card card-body">
      <div class="row align-items-center">
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="ano-sim">Ano</label>
            <select class="form-control" id="ano-sim" v-model="simulado.ano">
              <option v-if="anos.length > 0" value="">Selecione</option>
              <option v-for="ano in anos" :value="ano">{{ ano }}</option>
              <option v-if="anos.length == 0" value="">Carregando...</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="publico-sim">Público Alvo</label>
            <select class="form-control" id="publico-sim" v-model="simulado.publico_id">
              <option v-if="publicoAlvo.length > 0" value="">Selecione</option>
              <option v-for="publico in publicoAlvo" :value="publico.id">{{ publico.publico }}</option>
              <option v-if="publicoAlvo.length == 0" value="">Carregando...</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-3" v-if="fontesFiltradas && fontesFiltradas.length > 0">
          <div class="form-group">
            <label for="fonte-sim">Fonte</label>
            <select class="form-control" id="fonte-sim" v-model="simulado.fonte_id">
              <option value="">Selecione</option>
              <option v-for="fonte in fontesFiltradas" :value="fonte.id">{{ fonte.descricao }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-3" v-if="modalidadesDisponiveis && modalidadesDisponiveis.length > 0">
          <div class="form-group">
            <label for="modalidade-sim">Modalidade</label>
            <select class="form-control" id="modalidade-sim" v-model="simulado.modalidade_id">
              <option value="">Selecione</option>
              <option v-for="modalidade in modalidadesDisponiveis" :value="modalidade.id">{{ modalidade.descricao }}</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="curso-sim">Curso</label>
            <select class="form-control" id="curso-sim" v-model="simulado.curso_id">
              <option v-if="cursos.length > 0" value="">Selecione</option>
              <option v-for="curso in cursos" :value="curso.id">{{ curso.curso }}</option>
              <option v-if="cursos.length == 0" value="">Carregando...</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-3">
          <div class="form-group">
            <label for="tipo-sim">Tipo</label>
            <select class="form-control" id="tipo-sim" v-model="simulado.tipo_simulado_id">
              <option v-if="tiposSimulados.length > 0" value="">Selecione</option>
              <option v-for="tipo in tiposSimulados" :value="tipo.id">{{ tipo.descricao }}</option>
              <option v-if="tiposSimulados.length == 0" value="">Carregando...</option>
            </select>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-group">
            <label for="nome-sim">Nome</label>
            <input type="text" class="form-control" id="nome-sim" placeholder="" v-model="simulado.simulado">
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <h2 class="mt-1">Adicione as questões</h2>
      </div>
    </div>
    <div class="mt-3" id="selecQuestoes">
      <div class="card card-body limited-collapse">
        <form v-on:submit.prevent="buscarQuestoes">
          <div class="row">
            <div class="col-12 col-md-3">
              <b-link v-b-toggle.collapse-filter class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>
            </div>
            <div class="col-12 col-md-9 text-right text-md-right">
              <a href="javascript:void(0)" class="btn btn-secondary mr-3 mb-2 mb-md-0" @click="modalCadastrarQuestao()"><i class="fas fa-plus"></i> Adicionar Questão</a>
            </div>
          </div>
        </form>
        <b-collapse id="collapse-filter" class="filtros mt-3">
          <b-card>
            <form v-on:submit.prevent="buscarQuestoes">
              <div class="row align-items-center">
                <div class="col-12 col-md-11">
                  <div class="row">
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Tipo</label>
                        <select class="form-control" v-model="filtro.tipo">
                          <option value="1">Múltipla escolha</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label for="nome">Nome</label>
                        <input type="text" class="form-control" id="nome" placeholder="Nome da questão" v-model="filtro.nome" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label for="ano">Ano</label>
                        <input type="text" class="form-control" maxlength="4" id="ano" placeholder="Ano" v-model="filtro.ano" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label for="professor">Professor</label>
                        <select class="form-control" id="professor" v-model="filtro.professor">
                          <option v-if="professores.length > 0" value="">Selecione</option>
                          <option v-for="professor in professores" :value="professor.id" v-bind:key="professor.id">{{ professor.professor }}</option>
                          <option v-if="professores.length == 0" value="">Carregando...</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Enunciado</label>
                        <input type="text" class="form-control" placeholder="Enunciado da questão" v-model="filtro.enunciado" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>1ª opção de resposta</label>
                        <input type="text" class="form-control" placeholder="Descrição da opção" v-model="filtro.resposta1" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Comentário</label>
                        <input type="text" class="form-control" placeholder="Comentário da questão" v-model="filtro.comentario" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Curso</label>
                        <input type="text" class="form-control" placeholder="Nome do curso" v-model="filtro.curso" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Módulo</label>
                        <input type="text" class="form-control" placeholder="Nome do módulo" v-model="filtro.modulo" />
                      </div>
                    </div>
                    <div class="col-12 col-md-3">
                      <div class="form-group">
                        <label>Lição</label>
                        <input type="text" class="form-control" placeholder="Nome da Lição" v-model="filtro.licao" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-1">
                  <button v-b-toggle.collapse-filter type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
                </div>
              </div>
            </form>
          </b-card>
        </b-collapse>
        <div class="table-responsive tabela-usuarios mt-2 position-relative">
          <table class="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Enunciado</th>
                <th>Professor</th>
                <th>Curso</th>
                <th>Módulo</th>
                <th>Lição</th>
                <th>Data de Cadastro</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="questao in questoes" v-bind:key="questao.id">
                <td>{{ questao.questao }}</td>
                <td style="word-break: break-word;">{{ questao.enunciadoAbreviado }}</td>
                <td>{{ questao.professor && questao.professor.professor || '-' }}</td>
                <td>{{ questao.curso && questao.curso.curso || '-' }}</td>
                <td>{{ questao.modulo && questao.modulo.modulo || '-' }}</td>
                <td>{{ questao.licao && questao.licao.licao || '-' }}</td>
                <td>{{ questao.created_at | formatDatetime }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <i class="fas fa-check-circle" v-if="verificarQuestao(questao.id)"></i>
                    <a href="javascript:void(0)" title="Inserir no simulado" @click="inserirNoSimulado(questao)" v-else><i class="fa fa-plus"></i></a>
                  </div>
                </td>
            </tr>
            </tbody>
          </table>
          <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
              <div slot="no-results">Sua busca não retornou resultados</div>
              <div slot="no-more"></div>
          </infinite-loading>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12 col-md-6">
        <h2 class="mt-1">Visualização do seu simulado</h2>
      </div>
    </div>
    <div class="mt-3" id="selecQuestoes">
      <div class="card card-body limited-collapse">
        <div class="row">
          <div class="col-12 col-md-6">
            <h3 class="mt-4 mb-3">Seu simulado</h3>
          </div>
          <div class="col-12 col-md-6 text-center text-md-right">
            <a href="javascript:void(0)" id="cadastrar" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="editarSimulado"><i class="fas fa-check-circle"></i> Salvar e publicar </a>
          </div>
        </div>
        <div class="table-responsive tabela-usuarios mt-2 position-relative">
          <table class="table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Enunciado</th>
                <th>Professor</th>
                <th>Curso</th>
                <th>Módulo</th>
                <th>Lição</th>
                <th>Data de Cadastro</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(questao,index) in questoesArray" :key="index">
                <td>{{ questao.questao.questao }}</td>
                <td style="word-break: break-word;">{{ questao.questao.enunciado && questao.questao.enunciado.length > 600 ? questao.questao.enunciado.substring(0, 600) + '...' : questao.questao.enunciado }}</td>
                <td>{{ questao.questao.professor && questao.questao.professor.professor || '-' }}</td>
                <td>{{ questao.questao.curso && questao.questao.curso.curso || '-' }}</td>
                <td>{{ questao.questao.modulo && questao.questao.modulo.modulo || '-' }}</td>
                <td>{{ questao.questao.licao && questao.questao.licao.licao || '-' }}</td>
                <td>{{ questao.questao.created_at | formatDatetime }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirQuestaoNoSimulado(questao,index)"><i class="fas fa-trash-alt"></i></a>
                  </div>
                </td>
             </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalCadastroQuestao from '@/modules/Conteudo/components/ModalCadastroQuestao'
import QuestaoAPI from '@/api/questao-api'
import ProfessorAPI from '@/api/professor-api'
import SimuladoAPI from '@/api/simulado-api'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'SimuladosEdicao',
  components: {
    ModalCadastroQuestao,
    InfiniteLoading
  },
  props: {
    simulado_atual: Object,
    publicoAlvo: Array,
    fontes: Array,
    modalidades: Array,
    cursos: Array,
    tiposSimulados: Array
  },
  data () {
    return {
      simulado: {
        id: '',
        ano: '',
        simulado: '',
        curso_id: '',
        fonte_id: '',
        modalidade_id: '',
        publico_id: '',
        tipo_simulado_id: '',
        questaoArray: []
      },
      professores: [],
      modulos: [],
      licoes: [],
      questaoEdicao: null,
      publicoCarregado: false,
      fonteCarregada: false,
      pagina: 1,
      quantidade: 0,
      infiniteId: new Date(),
      questoes: [],
      filtro: {
        tipo: 1,
        nome: null,
        ano: null,
        professor: '',
        enunciado: '',
        resposta1: '',
        comentario: '',
        curso: '',
        modulo: '',
        licao: ''
      }
    }
  },
  computed: {
    anos () {
      const ano = new Date().getFullYear()
      return Array.from({ length: 7 }, (value, index) => ano - index)
    },

    modalidadesDisponiveis: function () {
      return this.modalidades.filter(modalidade => (
        modalidade.publico.id === this.simulado.publico_id &&
        modalidade.fonte.id === this.simulado.fonte_id
      ))
    },

    fontesFiltradas: function () {
      let modalidadesIds = []
      this.modalidades.map(modalidade => {
        modalidade.publico.id === this.simulado.publico_id &&
        modalidadesIds.push(modalidade.fonte.id)
      })
      return this.fontes.filter(fonte => {
        return modalidadesIds.includes(fonte.id)
      })
    },

    questoesArray: function () {
      let questoesArray = []
      this.simulado_atual.simulado_questao.map(questao => {
        questoesArray.push(questao)
      })
      return questoesArray
    }
  },

  watch: {
    'simulado.publico_id': function () {
      if (this.publicoCarregado) {
        this.simulado.fonte_id = null
        this.simulado.modalidade_id = null
      } else {
        this.publicoCarregado = true
      }
    },

    'simulado.fonte_id': function () {
      if (this.fonteCarregada) {
        this.simulado.modalidade_id = null
      } else {
        this.fonteCarregada = true
      }
    }
  },

  mounted () {
    this.simulado = {
      id: this.simulado_atual.id,
      ano: this.simulado_atual.ano,
      simulado: this.simulado_atual.simulado,
      curso_id: this.simulado_atual.curso_id,
      fonte_id: this.simulado_atual.fonte_id,
      modalidade_id: this.simulado_atual.modalidade_id,
      publico_id: this.simulado_atual.publico_id,
      tipo_simulado_id: this.simulado_atual.tipo_simulado
    }
    ProfessorAPI.listar().then(data => {
      this.professores = data
    })
    QuestaoAPI.listarModulos().then(data => {
      this.modulos = data
    })
    QuestaoAPI.listarLicoes().then(data => {
      this.licoes = data
    })
  },

  methods: {
    verificarQuestao: function (id) {
      let verificarId = obj => obj.questao_id === id
      return this.questoesArray.some(verificarId)
    },

    inserirNoSimulado: function (questao) {
      let questaoObjeto = {}
      questaoObjeto = {
        ordem: this.questoesArray.length + 1,
        resposta: 0,
        questao_id: questao.id,
        simulado_id: this.simulado_atual.id,
        questao: {}
      }
      questaoObjeto.questao = Object.assign({}, questao)
      this.questoesArray.push(questaoObjeto)
      this.buscarQuestoes()
    },

    excluirQuestaoNoSimulado: function (questao, index) {
      this.questoesArray.map(questaoArray => {
        questao.id === questaoArray.id &&
        this.questoesArray.splice(index, 1)
      })
      this.buscarQuestoes()
    },

    editarSimulado: function () {
      const loader = this.$loading.show()
      this.simulado.questaoArray = this.questoesArray
      SimuladoAPI.editar(this.simulado).then(data => {
        loader.hide()

        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Simulado atualizado com sucesso!'
        }).then(() => {
          this.$router.push('/conteudo/simulados')
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    },

    buscarQuestoes: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.questoes = []
    },

    infiniteHandler: function ($state) {
      QuestaoAPI.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.questoes.push(...data.data.map(item => {
            item.enunciadoAbreviado = item.enunciado && item.enunciado.length > 600 ? item.enunciado.substring(0, 600) + '...' : item.enunciado
            return item
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    },

    modalCadastrarQuestao: function () {
      this.questaoEdicao = null

      this.$nextTick(() => {
        this.$refs.modalCadastroQuestao.show()
      })
    }
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
